import { InputHTMLAttributes } from 'react';
import { Container } from './index.styles';

export const labelPositions = ['left', 'right'] as const;
export const sizes = ['sm', 'md', 'lg'] as const;

type RestProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'> & Component;

export interface ToggleProps extends RestProps {
  /**
   * ID attribute. Optional.
   */
  id?: string;
  /**
   * Label. Required.
   */
  label?: string;
  /**
   * Label position. Optional.
   */
  labelPosition?: (typeof labelPositions)[number];
  /**
   * Sizing variations. Optional.
   */
  size?: (typeof sizes)[number];
  /**
   * disabled state attribute. Optional.
   */
  disabled?: boolean;
}

/**
 * Toggle
 */
export const Toggle = ({
  className = '',
  customClass = '',
  id,
  size = 'md',
  label,
  labelPosition = 'left',
  testId = 'toggle',
  disabled = false,
  ...rest
}: ToggleProps) => {
  return (
    <Container
      className={`toggle toggle-${size} ${customClass} ${className}`}
      data-testid={testId}
      htmlFor={id}
      $isDisabled={disabled}
      $size={size}
    >
      {label && labelPosition === 'left' && label}
      <input
        id={id}
        type="checkbox"
        disabled={disabled}
        {...rest}
      />
      {label && labelPosition === 'right' && label}
    </Container>
  );
};
